import { Box, Button, Group, Text } from "@mantine/core";
import { IconCheck, IconRotate, IconTrash, IconX } from "@tabler/icons-react";
import { glassPanel } from "../lib/glass";

interface Props {
  onConfirm: () => void;
  onRotate: () => void;
  onCancel: () => void;
  onDelete?: () => void;
  showDelete?: boolean;
  showRotate?: boolean;
}

export function PlacementConfirmHUD({
  onConfirm,
  onRotate,
  onCancel,
  onDelete,
  showDelete = false,
  showRotate = true,
}: Props) {
  return (
    <Box
      style={{
        position: "absolute",
        bottom: 120,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 200,
        pointerEvents: "auto",
      }}
    >
      <Box
        p="xs"
        style={{
          ...glassPanel,
          borderRadius: 12,
        }}
      >
        <Group gap={8}>
          <Button
            color="green"
            size="sm"
            leftSection={<IconCheck size={14} />}
            onClick={onConfirm}
          >
            Confirm
          </Button>
          {showRotate && (
            <Button
              variant="light"
              color="gray"
              size="sm"
              leftSection={<IconRotate size={14} />}
              onClick={onRotate}
            >
              Rotate
            </Button>
          )}
          {showDelete && onDelete && (
            <Button
              color="red"
              variant="light"
              size="sm"
              leftSection={<IconTrash size={14} />}
              onClick={onDelete}
            >
              Delete
            </Button>
          )}
          <Button
            color="red"
            variant="subtle"
            size="sm"
            leftSection={<IconX size={14} />}
            onClick={onCancel}
          >
            Cancel
          </Button>
        </Group>
        <Text size="xs" c="gray.5" ta="center" mt={4}>
          {showDelete
            ? "Enter confirm / D delete / Esc cancel"
            : showRotate
            ? "Enter to confirm / R to rotate / Esc to cancel"
            : "Enter to confirm / Esc to cancel"}
        </Text>
      </Box>
    </Box>
  );
}
